import { BaseTextMergeEditor } from "../BaseTextMergeEditor";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";
import React from "react";
import { Box } from "@mui/material";
import DataArrayIcon from "@mui/icons-material/DataArray";
import { ExpressionView, ExpressionViewEmptyBehavior } from "../../../Expressions/ExpressionView";
import { InlineTextEdit } from "../../../CommonUI/InlineEditor/InlineTextEdit";
import { FieldElement } from "../../../rule-engine-core/TextMerge/Elements/Text/FieldElement";
import { BaseTextMergeElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

export class TextMergeFieldEditor extends BaseTextMergeEditor<FieldElement> {
    renderDisplay(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        return (
            <span
                style={
                    editContext.selectedElement?.id === this.getEditorData().id
                        ? {
                              border: "1px solid " + UIStyleConstants.GRAY_DARK_COLOR,
                              background: UIStyleConstants.BLUE_LIGHT_COLOR,
                          }
                        : { border: "1px solid " + UIStyleConstants.GRAY_DARK_COLOR }
                }
                onClick={() => {
                    editContext.setSelectedElement(config);
                }}
            >
                [!{this.editorData?.fieldName ?? "Field"}!]
            </span>
        );
    }

    renderEditor(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        return (
            <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                padding={"3px"}
                margin={"3px"}
                bgcolor={"white"}
                border={editContext.selectedElement?.id === config.id ? "2px solid red" : "1px solid blue"}
                onClick={() => {
                    editContext.setSelectedElement(config);
                }}
            >
                <InlineTextEdit
                    text={this.editorData!.fieldName}
                    onEdit={(newText) => {
                        this.editorData!.fieldName = newText;
                    }}
                ></InlineTextEdit>
                <ExpressionView
                    emptyBehavior={ExpressionViewEmptyBehavior.VARIABLE}
                    expression={this.editorData!.fieldData}
                />
            </Box>
        );
    }

    getIcon(): JSX.Element {
        return <DataArrayIcon />;
    }
}
